import React from 'react';

const Marquee: React.FC = () => {
  const text = 'СДАЧА В ГИБДД /// НОВЫЕ ИНОМАРКИ /// СВОЙ АВТОДРОМ /// ЧЕЛЯБИНСК /// ';

  return (
    <div className="absolute bottom-12 md:bottom-16 left-0 w-full py-3 bg-[#f97316] text-black z-20 overflow-hidden pointer-events-none">
      <div className="marquee-wrapper">
        <div className="marquee-track">
          <span className="marquee-text">
            {text.repeat(10)}
          </span>
          <span className="marquee-text" aria-hidden="true">
            {text.repeat(10)}
          </span>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Marquee);
